"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewPreferenceApiService = void 0;
var tslib_1 = require("tslib");
/* eslint-disable no-console */
var FosAuthorizer_1 = require("../auth/FosAuthorizer");
var cache_1 = require("../cache");
var utils_1 = require("../utils");
var ViewPreferenceApi = /** @class */ (function () {
    function ViewPreferenceApi() {
        var _this = this;
        // user-prefs v0: userId, user-prefs v1: email
        this.getUserId = function () { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var user, email, e_1;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, FosAuthorizer_1.FosAuthorizer.getUserInfo()];
                    case 1:
                        user = _a.sent();
                        if (!user) {
                            return [2 /*return*/, null];
                        }
                        email = (0, utils_1.getUserIdentifiers)(user).email;
                        return [2 /*return*/, email.toLowerCase()];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.getToken = function () { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                try {
                    return [2 /*return*/, FosAuthorizer_1.FosAuthorizer.getAuthorizationToken()];
                }
                catch (e) {
                    console.error(e);
                    return [2 /*return*/, "Error Fetching Token: ".concat(e)];
                }
                return [2 /*return*/];
            });
        }); };
        this.getClientId = function () { return cache_1.fosCache.getItem(cache_1.OBF_CLIENT_ID_CACHE_KEY); };
        this.makePathReplacements = function (url, options) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var clientId, userId, newUrl;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getClientId()];
                    case 1:
                        clientId = _a.sent();
                        return [4 /*yield*/, this.getUserId()];
                    case 2:
                        userId = _a.sent();
                        newUrl = url
                            .replace(/{clientId}/g, clientId)
                            .replace(/{userId}/g, userId);
                        if (options.pathParams) {
                            Object.keys(options.pathParams).forEach(function (param) {
                                var regex = new RegExp("{".concat(param, "}"), 'g');
                                newUrl = newUrl.replace(regex, options.pathParams[param]);
                            });
                        }
                        return [2 /*return*/, newUrl];
                }
            });
        }); };
    }
    ViewPreferenceApi.prototype.get = function (uri, options) {
        if (options === void 0) { options = {}; }
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var token, url, headers, fetchOptions, restData, completeUrl, fetchResponse, response, err_1;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getToken()];
                    case 1:
                        token = _a.sent();
                        return [4 /*yield*/, this.makePathReplacements(uri, options)];
                    case 2:
                        url = _a.sent();
                        headers = new Headers();
                        headers.append('Authorization', token);
                        headers.append('Accept', 'application/json');
                        fetchOptions = {
                            method: 'GET',
                            headers: {
                                Authorization: token,
                            },
                        };
                        completeUrl = "".concat(ntConfig.Rest.UserPrefApi.endpoint).concat(url);
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 8, , 9]);
                        return [4 /*yield*/, fetch(completeUrl, fetchOptions)];
                    case 4:
                        fetchResponse = _a.sent();
                        if (!fetchResponse.ok) return [3 /*break*/, 6];
                        return [4 /*yield*/, fetchResponse.json()];
                    case 5:
                        response = _a.sent();
                        restData =
                            typeof response === 'string' ? JSON.parse(response) : response;
                        return [3 /*break*/, 7];
                    case 6:
                        console.error('Fetch succeeded but could not get data', fetchResponse.statusText);
                        restData = {};
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        err_1 = _a.sent();
                        console.error('Could not fetch large data referecent', err_1);
                        restData = {};
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/, restData];
                }
            });
        });
    };
    ViewPreferenceApi.prototype.post = function (uri, options) {
        if (options === void 0) { options = {}; }
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var token, url, headers, fetchOptions, restData, completeUrl, fetchResponse, response, err_2;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getToken()];
                    case 1:
                        token = _a.sent();
                        return [4 /*yield*/, this.makePathReplacements(uri, options)];
                    case 2:
                        url = _a.sent();
                        headers = new Headers();
                        headers.append('Authorization', token);
                        fetchOptions = {
                            method: 'POST',
                            body: JSON.stringify(options.body),
                            headers: headers,
                        };
                        completeUrl = "".concat(ntConfig.Rest.UserPrefApi.endpoint).concat(url);
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 8, , 9]);
                        return [4 /*yield*/, fetch(completeUrl, fetchOptions)];
                    case 4:
                        fetchResponse = _a.sent();
                        if (!fetchResponse.ok) return [3 /*break*/, 6];
                        return [4 /*yield*/, fetchResponse.json()];
                    case 5:
                        response = _a.sent();
                        restData =
                            typeof response === 'string' ? JSON.parse(response) : response;
                        return [3 /*break*/, 7];
                    case 6:
                        console.error('Fetch succeeded but could not get data', fetchResponse.statusText);
                        restData = {};
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        err_2 = _a.sent();
                        console.error('Could not fetch large data', err_2);
                        restData = {};
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/, restData];
                }
            });
        });
    };
    ViewPreferenceApi.prototype.put = function (uri, options) {
        if (options === void 0) { options = {}; }
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var token, url, headers, fetchOptions, restData, completeUrl, fetchResponse, response, err_3;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getToken()];
                    case 1:
                        token = _a.sent();
                        return [4 /*yield*/, this.makePathReplacements(uri, options)];
                    case 2:
                        url = _a.sent();
                        headers = new Headers();
                        headers.append('Authorization', token);
                        fetchOptions = {
                            method: 'PUT',
                            body: JSON.stringify(options.body),
                            headers: headers,
                        };
                        completeUrl = "".concat(ntConfig.Rest.UserPrefApi.endpoint).concat(url);
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 8, , 9]);
                        return [4 /*yield*/, fetch(completeUrl, fetchOptions)];
                    case 4:
                        fetchResponse = _a.sent();
                        if (!fetchResponse.ok) return [3 /*break*/, 6];
                        return [4 /*yield*/, fetchResponse.json()];
                    case 5:
                        response = _a.sent();
                        restData =
                            typeof response === 'string' ? JSON.parse(response) : response;
                        return [3 /*break*/, 7];
                    case 6:
                        console.error('Fetch succeeded but could not get data', fetchResponse.statusText);
                        restData = {};
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        err_3 = _a.sent();
                        console.error('Could not fetch large data', err_3);
                        restData = {};
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/, restData];
                }
            });
        });
    };
    ViewPreferenceApi.prototype.delete = function (uri, options) {
        if (options === void 0) { options = {}; }
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var token, url, headers, fetchOptions, restData, completeUrl, fetchResponse, response, err_4;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getToken()];
                    case 1:
                        token = _a.sent();
                        return [4 /*yield*/, this.makePathReplacements(uri, options)];
                    case 2:
                        url = _a.sent();
                        headers = new Headers();
                        headers.append('Authorization', token);
                        fetchOptions = {
                            method: 'DELETE',
                            headers: headers,
                        };
                        completeUrl = "".concat(ntConfig.Rest.UserPrefApi.endpoint).concat(url);
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 8, , 9]);
                        return [4 /*yield*/, fetch(completeUrl, fetchOptions)];
                    case 4:
                        fetchResponse = _a.sent();
                        if (!fetchResponse.ok) return [3 /*break*/, 6];
                        return [4 /*yield*/, fetchResponse.json()];
                    case 5:
                        response = _a.sent();
                        restData =
                            typeof response === 'string' ? JSON.parse(response) : response;
                        return [3 /*break*/, 7];
                    case 6:
                        console.error('Fetch succeeded but could not get data', fetchResponse.statusText);
                        restData = {};
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        err_4 = _a.sent();
                        console.error('Could not fetch large data referecent', err_4);
                        restData = {};
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/, restData];
                }
            });
        });
    };
    return ViewPreferenceApi;
}());
var ViewPreferenceApiService = new ViewPreferenceApi();
exports.ViewPreferenceApiService = ViewPreferenceApiService;
